import React from 'react'
import {
    Container, List, Header, Form, Input, Label, Button, Card
} from 'semantic-ui-react'
import { TeeKOQRCode } from './TeeKOQRCode'
import '../styles/TeeKOImporter.css'

const domain = 'https://fishery.jackboxgames.com/artifact/TeeKOGame/'
const galleryDomain = process.env.REACT_APP_JACKBOX_TV_HOST || 'https://jackbox.tv'

export class TeeKOImporter extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            inputValue: '',
            error: null,
            galleries: []
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleRestart = this.handleRestart.bind(this)
        this.loadArtifact = this.loadArtifact.bind(this)
    }

    componentDidMount() {
        window.addEventListener('message', this.handleMessage.bind(this), false)
    }

    handleGalleriesFrameLoad(event) {
        event.target.contentWindow.postMessage({
            action: 'get'
        }, galleryDomain)
    }

    handleMessage(event) {
        if (event.origin !== galleryDomain) return
        const { action, galleries } = event.data
        if (action === 'returnData') {
            this.setState({
                galleries
            })
        }
    }

    handleChange(event, data) {
        // Find an artifact id out of it
        // games.jackbox.tv/artifact/TeeKOGame/ENPxfyDfjpQfMa08Zzsd1R7C0AsmoYQR/
        let artifactUrl = data.value
        if (artifactUrl.indexOf('/') !== -1) {
            const artifactChunks = artifactUrl.split('/')
            artifactUrl = artifactChunks.find((chunk) => chunk.length === 32)
        }
        if (!artifactUrl) return
        if (artifactUrl.length === 32) { // This is probably it?
            this.loadArtifact(artifactUrl)
        }
        this.setState({
            inputValue: artifactUrl,
            error: null
        })
    }

    handleRestart(event, data) {
        this.setState({
            loading: false,
            inputValue: '',
            artifact: null
        })
    }


    async loadArtifact(artifactId) {
        this.setState({
            artifact: null,
            loading: true
        }, async () => {
            const url = `${domain}${artifactId}`
            try {
                const response = await fetch(url)
                let artifact = await response.json()
                if (artifact.blob) artifact = artifact.blob
                this.setState({
                    artifact,
                    inputValue: artifactId,
                    loading: false
                })
            } catch (e) {
                this.setState({
                    error: e.toString(),
                    loading: false
                })
            }
        })
    }

    render() {
        const {
            artifact, inputValue, loading, galleries, error
        } = this.state
        const galleriesList = galleries.map((gallery, index) => {
            if (gallery.categoryId !== 'TeeKOGame') return false
            const time = new Date(gallery.time)
            const galleryDate = time.toLocaleDateString()
            const artifactId = gallery.url.split('/')[5]

            return (
                <Button key={index} className="galleryButton" onClick={() => { this.loadArtifact(artifactId) }}>{galleryDate}</Button>
            )
        }).filter((gallery) => gallery)
        
        // If we have the artifact, make an array of TeeKOShirts
        const qrCodeArray = []
        if (artifact && artifact.shirts) {
            artifact.shirts.forEach((shirt, i) => {
                qrCodeArray.push(
                    <TeeKOQRCode key={i} shirt={shirt} />
                )
            })
        }

        return (
            <div className="TeeKOImporter">
                <iframe
                    id="galleriesFrame"
                    title="Jackbox.tv"
                    className="visuallyhidden"
                    width="1"
                    height="1"
                    src={`${galleryDomain}/localstorage.html`}
                    onLoad={this.handleGalleriesFrameLoad}>
                </iframe>
                <Container className="Instructions">
                    <Header>How to get your Tee KO Shirts into Animal Crossing: New Horizons:</Header>
                    <List>
                        <List.Item>
                            <List.Header floated='left'>On your phone, download the Nintendo Switch Online app</List.Header>
                            Get the Nintendo Switch Online app from the <a href="https://apps.apple.com/us/app/nintendo-switch-online/id1234806557" target="_blank" rel="noopener noreferrer">Apple App Store</a> or the <a href="https://play.google.com/store/apps/details?id=com.nintendo.znca" target="_blank" rel="noopener noreferrer">Google Play App Store</a>
                        </List.Item>
                        <List.Item>
                            <List.Header>In Animal Crossing: New Horizons, connect your account</List.Header>
                            Follow the instructions in the Nintendo Switch Online app to set up your connection to the Animal Crossing: New Horizons game
                        </List.Item>
                        <List.Item>
                            <List.Header>In Nintendo Switch Online: Scan a QR Code</List.Header>
                            Open the Animal Crossing service (NookLink). Select the &quot;Designs&quot; tile, then press &quot;Scan a QR Code&quot;
                        </List.Item>
                        <List.Item>
                            <List.Header>In Animal Crossing: New Horizons, Download the design</List.Header>
                            Open your NookPhone, and select Custom Designs. Press the &apos;+&apos; to download the saved pattern.
                        </List.Item>
                    </List>
                </Container>
                { (galleriesList.length > 0)
                    && <Container>
                        <Header textAlign="center">Choose a Past TeeKO Game</Header>
                        {galleriesList}
                    </Container>
                }

                <Container>
                    <Header textAlign="center">Enter a Tee KO Gallery URL</Header>
                </Container>
                <Container className="ArtifactForm">
                    { !artifact
                        && <Form>
                            <Form.Field>
                                <Input fluid loading={loading} iconPosition='left' value={inputValue} onChange={this.handleChange} placeholder='Enter your Artifact ID' disabled={loading} />
                                { error
                                    && <Label basic color='red' pointing>{error}</Label>
                                }
                            </Form.Field>
                        </Form>
                    }
                    { artifact
                        && <div>
                            <Label>{inputValue}</Label>
                            <Button className="galleryButton" onClick={this.handleRestart}>X</Button>
                        </div>
                    }
                </Container>
                { artifact
                    && <Container>
                        <Card.Group>
                            {qrCodeArray}
                        </Card.Group>
                    </Container>
                }
            </div>
        )
    }
}
